(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MOBILE_MQ = window.matchMedia('(max-width: 749px)');
  var DESKTOP_MQ = window.matchMedia('(min-width: 990px)');

  var REVEAL_MARGIN = '0px 0px -8% 0px';
  var REVEAL_THRESHOLD = 0.12;

  var heroMotion = {
    root: null,
    stage: null,
    parallaxEl: null,
    active: false,
    ticking: false,
    scrollY: 0,
    pointerX: 0,
    pointerY: 0,
    hasPointer: false
  };

  function isMobile() {
    return MOBILE_MQ.matches;
  }

  function isDesktop() {
    return DESKTOP_MQ.matches;
  }

  function revealNodes(nodes) {
    if (!nodes) return;
    var list = nodes.length !== undefined ? nodes : [nodes];
    list.forEach(function (node) {
      if (node) {
        node.classList.add('is-visible');
        node.classList.add('is-in-view');
      }
    });
  }

  function observeOnce(elements, callback, options) {
    if (!elements.length) return null;
    if (REDUCED || !('IntersectionObserver' in window)) {
      elements.forEach(function (el) {
        callback(el, true);
      });
      return null;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          callback(entry.target, false);
          observer.unobserve(entry.target);
        });
      },
      Object.assign({ threshold: REVEAL_THRESHOLD, rootMargin: REVEAL_MARGIN }, options || {})
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });

    return observer;
  }

  function whenHeroImageReady(mediaStage, callback) {
    var img = mediaStage.querySelector('.product__media-item.is-active .pdp-media-hover img, .product__media-item.is-active img');
    if (!img) {
      callback(null);
      return;
    }

    function done() {
      callback(img);
    }

    if (img.complete && img.naturalWidth > 0) {
      if (img.decode) {
        img.decode().then(done).catch(done);
      } else {
        done();
      }
      return;
    }

    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
    window.setTimeout(done, 1200);
  }

  function getActiveParallaxEl(mediaStage) {
    var active = mediaStage.querySelector('.product__media-item.is-active .pdp-media-parallax');
    return active || mediaStage.querySelector('.pdp-media-parallax');
  }

  function runHeroEntrance(mediaStage) {
    mediaStage.classList.add('is-media-ready', 'is-entering');
    window.setTimeout(function () {
      mediaStage.classList.remove('is-entering');
      mediaStage.classList.add('is-ready');
    }, isMobile() ? 780 : 720);
  }

  function updateHeroMotion() {
    heroMotion.ticking = false;
    if (!heroMotion.root || !heroMotion.parallaxEl || REDUCED) return;

    var rect = heroMotion.root.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;

    if (rect.bottom < 0 || rect.top > vh) {
      heroMotion.active = false;
      heroMotion.parallaxEl.style.transform = '';
      return;
    }

    heroMotion.active = true;
    var progress = Math.min(Math.max(-rect.top / (rect.height || 1), 0), 1);
    var scrollOffset = progress * (isDesktop() ? 12 : 5);
    var pointerX = 0;
    var pointerY = 0;

    if (isDesktop() && heroMotion.hasPointer && heroMotion.stage) {
      var stageRect = heroMotion.stage.getBoundingClientRect();
      var relX = (heroMotion.pointerX - stageRect.left) / (stageRect.width || 1) - 0.5;
      var relY = (heroMotion.pointerY - stageRect.top) / (stageRect.height || 1) - 0.5;
      pointerX = Math.max(-4, Math.min(4, relX * 8));
      pointerY = Math.max(-3, Math.min(3, relY * 6));
    }

    heroMotion.parallaxEl.style.transform =
      'translate3d(' + pointerX + 'px, ' + (scrollOffset + pointerY) + 'px, 0)';
  }

  function requestHeroMotion() {
    if (heroMotion.ticking || REDUCED) return;
    heroMotion.ticking = true;
    window.requestAnimationFrame(updateHeroMotion);
  }

  function initHeroMotion(root, mediaStage) {
    heroMotion.root = root;
    heroMotion.stage = mediaStage;
    heroMotion.parallaxEl = getActiveParallaxEl(mediaStage);

    if (REDUCED) {
      mediaStage.classList.add('is-media-ready', 'is-ready');
      return;
    }

    // Phase 6: only a photo that is still downloading is held back for the soft-light reveal;
    // one that is already on screen is never hidden again.
    var heroImg = mediaStage.querySelector('.product__media-item.is-active img');
    if (heroImg && !(heroImg.complete && heroImg.naturalWidth > 0)) mediaStage.classList.add('is-media-pending');

    whenHeroImageReady(mediaStage, function () {
      heroMotion.parallaxEl = getActiveParallaxEl(mediaStage);
      mediaStage.classList.remove('is-media-pending');
      runHeroEntrance(mediaStage);
      requestHeroMotion();
    });

    window.addEventListener('scroll', requestHeroMotion, { passive: true });

    if (isDesktop()) {
      mediaStage.addEventListener('mousemove', function (event) {
        heroMotion.hasPointer = true;
        heroMotion.pointerX = event.clientX;
        heroMotion.pointerY = event.clientY;
        requestHeroMotion();
      });

      mediaStage.addEventListener('mouseleave', function () {
        heroMotion.hasPointer = false;
        requestHeroMotion();
      });
    }

    var gallery = mediaStage.querySelector('media-gallery');
    var viewer = gallery && gallery.querySelector('[id^="GalleryViewer"]');
    if (viewer) {
      viewer.addEventListener('slideChanged', function () {
        heroMotion.parallaxEl = getActiveParallaxEl(mediaStage);
        requestHeroMotion();
      });
    }
  }

  function collectPurchaseItems(purchase) {
    var items = [];
    var push = function (el, role) {
      if (el && !el.classList.contains('visibility-hidden')) {
        el.classList.add('pdp-purchase-item', 'pdp-purchase-item--' + role);
        items.push(el);
      }
    };

    push(purchase.querySelector(':scope > .product-premium__vendor'), 'vendor');
    push(purchase.querySelector(':scope > .product__title'), 'title');
    push(purchase.querySelector(':scope > .product-premium__meta'), 'meta');
    push(purchase.querySelector(':scope > [id^="price-"]'), 'price');

    var variants = purchase.querySelector('variant-selects');
    if (variants) {
      if (isMobile()) {
        variants.querySelectorAll('.product-form__input').forEach(function (el) {
          push(el, 'variant');
        });
      } else {
        push(variants, 'variants');
      }
    }

    var actions = purchase.querySelector(':scope > .product-premium__actions');
    if (actions) {
      if (isMobile()) {
        push(actions.querySelector('.product-form__quantity'), 'quantity');
        push(actions.querySelector('product-form, .product-form'), 'atc');
        var paymentBtn = actions.querySelector('.shopify-payment-button');
        if (paymentBtn) push(paymentBtn, 'buynow');
      } else {
        push(actions, 'actions');
      }
    }

    push(purchase.querySelector(':scope > .product-premium__micro-trust'), 'trust');
    return items;
  }

  function runPurchaseEntrance(purchase) {
    var items = collectPurchaseItems(purchase);
    if (!items.length) return;

    var step = isMobile() ? 70 : 65;

    items.forEach(function (item, index) {
      item.style.setProperty('--pdp-enter-delay', index * step + 'ms');
    });

    purchase.classList.add('is-purchase-entering');

    window.setTimeout(function () {
      purchase.classList.remove('is-purchase-entering');
      items.forEach(function (item) {
        item.classList.add('is-entered');
      });
    }, items.length * step + (isMobile() ? 680 : 640));
  }

  function initQuantityFeedback(root) {
    root.querySelectorAll('.quantity__input').forEach(function (input) {
      input.addEventListener('change', function () {
        input.classList.remove('is-qty-pulse');
        void input.offsetWidth;
        input.classList.add('is-qty-pulse');
        window.setTimeout(function () {
          input.classList.remove('is-qty-pulse');
        }, 220);
      });
    });
  }

  function enhanceDescriptionReveals(container) {
    if (!container || container.dataset.revealEnhanced === 'true') return;
    container.dataset.revealEnhanced = 'true';

    Array.from(container.children).forEach(function (child) {
      if (child.matches('h2, h3')) {
        child.classList.add('pdp-reveal', 'pdp-reveal--title', 'pdp-reveal--clip');
      } else if (child.matches('h4, h5, h6')) {
        child.classList.add('pdp-reveal', 'pdp-reveal--line');
      } else if (child.matches('p')) {
        child.classList.add('pdp-reveal', 'pdp-reveal--text');
      } else if (child.matches('ul, ol')) {
        child.classList.add('pdp-reveal', 'pdp-reveal--list');
        child.querySelectorAll(':scope > li').forEach(function (li, index) {
          li.classList.add('pdp-reveal', 'pdp-reveal--text', 'pdp-reveal--stagger');
          li.style.setProperty('--pdp-stagger', index * 55 + 'ms');
        });
      } else if (child.matches('table')) {
        child.classList.add('pdp-reveal', 'pdp-reveal--table');
        child.querySelectorAll('tbody tr, tr').forEach(function (row, index) {
          row.classList.add('pdp-reveal', 'pdp-reveal--soft', 'pdp-reveal--stagger');
          row.style.setProperty('--pdp-stagger', 80 + index * 50 + 'ms');
        });
      } else {
        child.classList.add('pdp-reveal', 'pdp-reveal--soft');
      }
    });
  }

  function initRevealElements(scope) {
    var reveals = scope.querySelectorAll('.pdp-reveal');
    if (!reveals.length) return;

    if (REDUCED) {
      revealNodes(reveals);
      return;
    }

    observeOnce(Array.from(reveals), function (el) {
      el.classList.add('is-visible');
      if (el.classList.contains('pdp-reveal--list')) {
        el.querySelectorAll('.pdp-reveal--stagger').forEach(function (li) {
          li.classList.add('is-visible');
        });
      }
      if (el.classList.contains('pdp-reveal--table')) {
        window.setTimeout(function () {
          el.querySelectorAll('.pdp-reveal--stagger').forEach(function (row) {
            row.classList.add('is-visible');
          });
        }, 260);
      }
    });
  }

  function initSectionInView(section, onEnter) {
    if (!section) return;

    if (REDUCED) {
      section.classList.add('is-in-view');
      if (onEnter) onEnter(section, true);
      return;
    }

    observeOnce([section], function (el) {
      el.classList.add('is-in-view');
      if (onEnter) onEnter(el, false);
    }, { threshold: 0.1, rootMargin: REVEAL_MARGIN });
  }

  function initStorySection(story) {
    if (!story) return;

    var description = story.querySelector('.product-premium__description');
    if (description) enhanceDescriptionReveals(description);

    initSectionInView(story, function () {
      story.classList.add('is-story-visible');
      window.setTimeout(function () {
        initRevealElements(story);
      }, isMobile() ? 280 : 200);
    });
  }

  function initDetailsSection(details) {
    if (!details) return;

    var title = details.querySelector('.product-premium__details-title');
    if (title) title.classList.add('pdp-reveal', 'pdp-reveal--title', 'pdp-reveal--clip');

    details.querySelectorAll('.product__accordion').forEach(function (accordion, index) {
      accordion.classList.add('pdp-reveal', 'pdp-reveal--soft', 'pdp-reveal--stagger');
      accordion.style.setProperty('--pdp-stagger', index * 70 + 'ms');
    });

    initSectionInView(details, function () {
      initRevealElements(details);
    });

    initAccordions(details);
  }

  function initAccordions(scope) {
    scope.querySelectorAll('.product-premium__details .product__accordion details').forEach(function (detailsEl) {
      detailsEl.addEventListener('toggle', function () {
        detailsEl.classList.toggle('is-accordion-open', detailsEl.open);
      });
      if (detailsEl.open) detailsEl.classList.add('is-accordion-open');
    });
  }

  function initProductPremium(root) {
    if (!root || root.dataset.premiumInit === 'true') return;
    root.dataset.premiumInit = 'true';

    var mediaStage = root.querySelector('.product-premium__media-stage');
    var purchase = root.querySelector('.product-premium__purchase');
    var stickyBar = root.querySelector('.product-premium__sticky-bar');
    var purchaseAnchor = root.querySelector('[data-premium-purchase]');
    var mainAtc = root.querySelector('#ProductSubmitButton-' + root.dataset.sectionId);
    var stickyAtc = root.querySelector('[data-premium-sticky-atc]');
    var story = root.querySelector('.product-premium__story');
    var details = root.querySelector('.product-premium__details');

    if (REDUCED) {
      root.classList.add('is-motion-reduced');
      if (mediaStage) mediaStage.classList.add('is-media-ready', 'is-ready');
      if (story) {
        story.classList.add('is-story-visible', 'is-in-view');
        initRevealElements(story);
      }
    } else {
      root.classList.add('is-motion-enhanced');

      if (mediaStage) initHeroMotion(root, mediaStage);

      if (purchase) {
        if (isMobile()) {
          whenHeroImageReady(mediaStage || root, function () {
            window.setTimeout(function () {
              runPurchaseEntrance(purchase);
            }, 760);
          });
        } else {
          runPurchaseEntrance(purchase);
        }
      }

      initQuantityFeedback(root);
    }

    initStorySection(story);
    initDetailsSection(details);

    if (stickyBar && purchaseAnchor && mainAtc && stickyAtc && 'IntersectionObserver' in window) {
      var stickyTitle = stickyBar.querySelector('.product-premium__sticky-title');
      var stickyVariant = stickyBar.querySelector('.product-premium__sticky-variant');

      function syncStickyState() {
        var disabled = mainAtc.disabled;
        stickyAtc.disabled = disabled;
        stickyAtc.textContent = mainAtc.textContent.trim();

        var titleEl = root.querySelector('.product-premium__purchase .product__title h1');
        if (stickyTitle && titleEl) stickyTitle.textContent = titleEl.textContent.trim();

        var selectedValue = root.querySelector('[data-selected-value]');
        if (stickyVariant) {
          stickyVariant.textContent = selectedValue ? selectedValue.textContent.trim() : '';
          stickyVariant.hidden = !selectedValue || !selectedValue.textContent.trim();
        }
      }

      syncStickyState();

      // Show only once the purchase panel has scrolled fully above the
      // viewport — never while it is still below the fold on a short screen.
      // A scroll check (not IntersectionObserver) so fast flings or jumps that
      // skip the "visible" state still update the bar.
      var stickyShown = null;
      var stickyQueued = false;
      function updateSticky() {
        stickyQueued = false;
        var show = purchaseAnchor.getBoundingClientRect().bottom <= 0;
        if (show === stickyShown) return;
        stickyShown = show;
        stickyBar.classList.toggle('is-visible', show);
        stickyBar.hidden = !show;
        document.body.classList.toggle('product-premium-sticky-active', show);
      }
      function requestSticky() {
        if (stickyQueued) return;
        stickyQueued = true;
        window.requestAnimationFrame(updateSticky);
      }
      window.addEventListener('scroll', requestSticky, { passive: true });
      window.addEventListener('resize', requestSticky);
      updateSticky();

      stickyAtc.addEventListener('click', function () {
        if (!mainAtc.disabled) mainAtc.click();
      });

      root.addEventListener('product-info:loaded', syncStickyState);

      document.addEventListener('change', function (event) {
        if (root.contains(event.target)) {
          window.setTimeout(syncStickyState, 60);
        }
      });
    } else if (stickyBar) {
      stickyBar.hidden = true;
    }
  }

  function revealRelatedAll(section, cards, eyebrow, heading) {
    if (eyebrow) eyebrow.classList.add('is-visible');
    if (heading) heading.classList.add('is-visible');
    cards.forEach(function (card) {
      card.classList.add('is-visible');
    });
    section.classList.add('is-related-revealed', 'is-in-view');
  }

  function initRelatedProductsPremium(section) {
    if (!section) return;

    var recommendations = section.querySelector('product-recommendations');
    if (!recommendations) return;

    function setup() {
      var cards = recommendations.querySelectorAll('.product-premium-related__card-item');
      if (!cards.length) return;
      if (section.dataset.relatedMotionReady === 'true') return;
      section.dataset.relatedMotionReady = 'true';

      var eyebrow = section.querySelector('.product-premium-related__eyebrow');
      var heading = section.querySelector('.product-premium-related__heading');
      var header = section.querySelector('.product-premium-related__header') || recommendations;

      if (REDUCED) {
        section.classList.add('is-motion-reduced');
        revealRelatedAll(section, cards, eyebrow, heading);
        return;
      }

      section.classList.add('is-motion-enhanced');

      if (!('IntersectionObserver' in window)) {
        revealRelatedAll(section, cards, eyebrow, heading);
        return;
      }

      var headerRevealed = false;

      function revealHeaderThenCards() {
        if (headerRevealed) return;
        headerRevealed = true;
        section.classList.add('is-in-view');

        if (eyebrow) {
          eyebrow.classList.add('is-visible');
          window.setTimeout(function () {
            if (heading) heading.classList.add('is-visible');
            window.setTimeout(startCardReveals, 90);
          }, 70);
        } else if (heading) {
          heading.classList.add('is-visible');
          window.setTimeout(startCardReveals, 90);
        } else {
          startCardReveals();
        }
      }

      function startCardReveals() {
        if (isMobile()) {
          observeOnce(Array.from(cards), function (card) {
            var index = parseInt(card.dataset.relatedIndex || '0', 10);
            var col = index % 2;
            window.setTimeout(function () {
              card.classList.add('is-visible');
            }, col * 65);
          }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
        } else {
          cards.forEach(function (card, index) {
            window.setTimeout(function () {
              card.classList.add('is-visible');
            }, index * 75);
          });
        }
        section.classList.add('is-related-revealed');
      }

      observeOnce([header], revealHeaderThenCards, { threshold: 0.08, rootMargin: '0px 0px 10% 0px' });
    }

    setup();

    if (recommendations.dataset.relatedWatchInit !== 'true') {
      recommendations.dataset.relatedWatchInit = 'true';
      var loadObserver = new MutationObserver(setup);
      loadObserver.observe(recommendations, { childList: true, subtree: true });
    }
  }

  function initTrustPremium(section) {
    if (!section || section.dataset.trustMotionReady === 'true') return;

    var items = section.querySelectorAll('.pdp-trust-item');
    if (!items.length) return;
    section.dataset.trustMotionReady = 'true';

    items.forEach(function (item, index) {
      item.style.setProperty('--pdp-trust-delay', index * 80 + 'ms');
    });

    if (REDUCED) {
      section.classList.add('is-motion-reduced');
      items.forEach(function (item) {
        item.classList.add('is-visible');
      });
      section.classList.add('is-in-view');
      return;
    }

    section.classList.add('is-motion-enhanced');

    initSectionInView(section, function () {
      items.forEach(function (item, index) {
        window.setTimeout(function () {
          item.classList.add('is-visible');
        }, index * 80);
      });
    });
  }

  function boot() {
    document.querySelectorAll('product-info.product-premium').forEach(initProductPremium);
    document.querySelectorAll('.product-premium-trust').forEach(initTrustPremium);
    document.querySelectorAll('.product-premium-related').forEach(initRelatedProductsPremium);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
